import { useApiToast } from 'components/Toaster';
import { getDatalists } from 'features/datalist/datalist.slice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AgendaEvent } from 'services/agenda/agenda.types';
import { useGetPersonsMutation } from 'services/person/person.endpoint';
import { Person } from 'services/person/person.types';

export default function useNextEventsVM() {
    const { datalists } = useSelector(getDatalists);
    const [currentEvent, setCurrentEvent] = useState<AgendaEvent>();

    return {
        datalists,
        currentEvent,
        setCurrentEvent
    };
}
